import siFetch from "api/fetch";

import handleParams from "api/handle-params";

const record = (params = "", init = null) =>
  siFetch(`/api/v1/agent/report${handleParams(params)}`, init);

export default record;
